import { createAction, props } from '@ngrx/store';

const UPDATE_ACTION = 'UPDATE RADIUS OVERRIDE';
const RESET_ACTION = 'RESET RADIUS OVERRIDE';

export const updateRadiusOverride = createAction(
  UPDATE_ACTION,
  props<{ overrideRadius: boolean }>()
);

export const resetRadiusOverride = createAction(RESET_ACTION);
